import { memo } from "react";
import { Box } from "@mui/material";
import * as styles from "./styles";

export const Loader = memo(() => {
  return (
    <Box display="flex" flex="1 1" sx={styles.container}>
      <img
        src={require("@assets/gifs/loadingAirTour.gif").default}
        width="120"
        alt="Iran Airtour"
      />
    </Box>
  );
});
